// Celular confirmado pelo WhatsApp (0.44): no cadastro e ao trocar de número. Um número por conta.
import { useSyncExternalStore } from 'react';
import { supabase } from './supabase';
import { DEMO } from './env';
import { t } from './i18n';

// ligado: o servidor tem a confirmação pelo WhatsApp configurada (0.71: sem ela, Ajustes não mostra "Celular confirmado").
type Estado = { checado: boolean; exigir: boolean; telefone: string | null; ligado: boolean };
let st: Estado = { checado: false, exigir: false, telefone: null, ligado: false };
const ouv = new Set<() => void>();
const set = (p: Partial<Estado>) => { st = { ...st, ...p }; ouv.forEach(f => f()); };
export const useCelular = () => useSyncExternalStore(f => { ouv.add(f); return () => { ouv.delete(f); }; }, () => st, () => st);

async function chamar(corpo: object): Promise<any> {
  const { data, error } = await supabase!.functions.invoke('celular', { body: corpo });
  if (error) {
    try { const c = await (error as any).context?.json?.(); if (c) return c; } catch { /* segue */ }
    throw new Error(String(error.message ?? error));
  }
  return data;
}

/** Confere se a conta já tem o celular confirmado. Se o servidor ainda não tiver o WhatsApp ligado, não exige. */
export async function conferirCelular() {
  if (DEMO || !supabase) return set({ checado: true, exigir: false, ligado: false });
  try {
    const r = await chamar({ acao: 'situacao' });
    if (r?.codigo === 'sem-whatsapp') return set({ checado: true, exigir: false, telefone: null, ligado: false });
    set({ checado: true, telefone: r?.telefone ?? null, exigir: !!r?.ok && !r?.telefone, ligado: true });
  } catch { set({ checado: true, exigir: false }); }   // sem internet ou função ainda não publicada: não trava o app
}

/** Para o painel de estado: a confirmação pelo WhatsApp está ligada no servidor? */
export async function whatsappLigado(): Promise<boolean | null> {
  if (DEMO || !supabase) return false;
  try { const r = await chamar({ acao: 'situacao' }); return r?.codigo !== 'sem-whatsapp'; } catch { return null; }
}

export async function enviarCodigo(telefone: string) {
  const r = await chamar({ acao: 'enviar', telefone });
  if (!r?.ok) throw new Error(r?.codigo === 'sem-whatsapp' ? t('A confirmação pelo WhatsApp ainda não foi ligada no servidor.') : r?.erro ?? t('Não foi possível enviar.'));
}
export async function confirmarCodigo(codigo: string) {
  const r = await chamar({ acao: 'confirmar', codigo });
  if (!r?.ok) throw new Error(r?.erro ?? t('Código errado. Confira e tente de novo.'));
  set({ exigir: false, telefone: r.telefone });
  return r.telefone as string;
}
